import UploadImageLayout from "./UploadImageLayout";

export default UploadImageLayout;
